import { useContext } from 'react';

import CategoryFilters from '@atom/components/common/categoryFilters/CategoryFilters';
import WorkOrdersContext, {
  FilterSection,
  WorkOrdersInputActionTypes,
} from '@atom/components/workOrders/WorkOrdersContext';
import { useSchemas } from '@atom/hooks/useSchemas';
import { Icon, IconButton, Select } from '@atom/mui';
import {
  CategoryIcon,
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon,
} from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { toggleFromSet } from '@atom/utilities/setUtilities';

import classes from './workOrdersFilters.module.css';

const { MenuItem } = Select;

const styles = {
  icon: {
    marginRight: '1rem',
  },
};

const inputLabelSx = {
  color: `${colors.neutral.dim} !important`,
};

const WorkOrdersFiltersInventorySection = () => {
  const {
    collapsedSections,
    setCollapsedSections,
    workOrdersInputCart,
    filtersDisabled,
    dispatch,
  } = useContext(WorkOrdersContext);

  const { schemas, loading: loadingSchemas } = useSchemas();

  const onToggle = (section: FilterSection) => {
    setCollapsedSections(toggleFromSet(collapsedSections, section));
  };

  const handleChange = (event: any) => {
    dispatch({
      type: WorkOrdersInputActionTypes.UPDATE_WORK_ORDERS_INPUT_PROPERTY,
      data: {
        property: 'assetSchemaId',
        value: event.target.value,
      },
    });
  };

  const updateCategoryIds = (categoryIds: string[]) => {
    dispatch({
      type: WorkOrdersInputActionTypes.UPDATE_WORK_ORDERS_INPUT_PROPERTY,
      data: {
        property: 'categoryIds',
        value: categoryIds,
      },
    });
  };

  return (
    <div className={classes.filtersSection}>
      <div className={classes.filtersSectionHeader}>
        <div>
          <Icon style={styles.icon} icon={CategoryIcon} />
          Inventory
        </div>
        <IconButton
          onClick={() => onToggle(FilterSection.INVENTORY)}
          edge="end"
        >
          <Icon
            icon={
              collapsedSections.has(FilterSection.INVENTORY)
                ? KeyboardArrowDownIcon
                : KeyboardArrowUpIcon
            }
          />
        </IconButton>
      </div>
      {!collapsedSections.has(FilterSection.INVENTORY) && (
        <div className={classes.filtersSectionContent}>
          <div className={classes.filterContainer}>
            <Select
              displayEmpty
              label="Type"
              value={workOrdersInputCart?.assetSchemaId || ''}
              onChange={handleChange}
              renderValue={
                workOrdersInputCart?.assetSchemaId ? null : () => 'All'
              }
              disabled={loadingSchemas || filtersDisabled}
              loading={loadingSchemas}
              inputLabelSx={inputLabelSx}
            >
              <MenuItem value="" />
              {schemas.map(schema => (
                <MenuItem key={schema.id} value={schema.id}>
                  {schema.name}
                </MenuItem>
              ))}
            </Select>
          </div>
          <div className={classes.filterContainer}>
            <CategoryFilters
              categoryIds={workOrdersInputCart.categoryIds}
              updateCategoryIds={updateCategoryIds}
              filtersDisabled={filtersDisabled}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkOrdersFiltersInventorySection;
